<template>
  <div class="card">
    <div class="card-header">
      <h2>Datos de la capa</h2>
    </div>

    <div class="card-body">
      <div class="form-grid">

        <!-- Nombre -->
        <div class="form-row">
          <label for="arcgis-nombre">Nombre <span class="required-indicator">*</span><FieldHelp label="el nombre de la capa" :text="help.nombre" /></label>
          <input
            id="arcgis-nombre"
            type="text"
            class="input"
            :value="formData.nombre"
            @input="updateField('nombre', $event.target.value)"
            required
          />
        </div>

        <div class="form-row">
          <label for="arcgis-descripcion">Descripción <span class="required-indicator">*</span><FieldHelp label="la descripción" :text="help.descripcion" /></label>
          <input
            id="arcgis-descripcion"
            type="text"
            class="input"
            :value="formData.descripcion"
            @input="updateField('descripcion', $event.target.value)"
            required
          />
        </div>

        <div class="form-row">
          <label for="arcgis-url">Url <span class="required-indicator">*</span><FieldHelp label="la URL del servicio" :text="help.url" /></label>
          <div>
            <input
              id="arcgis-url"
              type="url"
              class="input"
              :value="formData.url"
              @input="updateField('url', $event.target.value)"
              required
            />
            <small class="error-text" v-if="formData.url && urlError">{{ urlError }}</small>
          </div>
        </div>

        <!-- Código -->
        <div class="form-row" v-if="!isImageServer">
          <label for="arcgis-codigo">Código<FieldHelp label="el código" :text="help.codigo" /></label>
          <input
            id="arcgis-codigo"
            type="text"
            class="input"
            :value="formData.codigo"
            @input="updateField('codigo', $event.target.value)"
          />
        </div>

        <!-- Fuente -->
        <div class="form-row">
          <label for="arcgis-fuente">Fuente<FieldHelp label="la fuente" :text="help.fuente" /></label>
          <input
            id="arcgis-fuente"
            type="text"
            class="input"
            :value="formData.fuente"
            @input="updateField('fuente', $event.target.value)"
          />
        </div>

        <div class="form-row">
          <label for="arcgis-fecha-dato">Fecha del dato</label>
          <input
            id="arcgis-fecha-dato"
            type="date"
            class="input"
            :value="formData.fechaDato"
            @input="updateField('fechaDato', $event.target.value)"
          />
        </div>

        <div class="form-row">
          <label for="arcgis-fecha-actualizacion">Fecha de actualización</label>
          <input
            id="arcgis-fecha-actualizacion"
            type="date"
            class="input"
            :value="formData.fechaActualizacion"
            @input="updateField('fechaActualizacion', $event.target.value)"
          />
        </div>

        <!-- Vulnerable -->
        <div class="form-row">
          <label for="arcgis-vulnerable">I. vulnerable Modelación/Geoprocesos? <span class="required-indicator">*</span><FieldHelp label="vulnerable a modelación y geoprocesos" :text="help.esVulnerable" /></label>
          <select
            id="arcgis-vulnerable"
            class="input"
            :value="formData.esVulnerable"
            @change="updateField('esVulnerable', $event.target.value)"
            required
          >
            <option value="NO">NO</option>
            <option value="SI">SI</option>
          </select>
        </div>

        <VulnerableReportIconField
          :value="formData.reportIconSvg || ''"
          :vulnerable="formData.esVulnerable === 'SI'"
          @input="updateField('reportIconSvg', $event)"
        />

        <!-- Cap Población -->
        <div class="form-row">
          <label for="arcgis-cap-poblacion">Cap población <span class="required-indicator">*</span><FieldHelp label="la capa de población" :text="help.capPoblacion" /></label>
          <select
            id="arcgis-cap-poblacion"
            class="input"
            :value="formData.capPoblacion"
            @change="updateField('capPoblacion', $event.target.value)"
            required
          >
            <option value="poligonos">Polígonos</option>
            <option value="puntos">Puntos</option>
            <option value="NO">NO</option>
          </select>
        </div>

        <!-- Categoría -->
        <div class="form-row">
          <label for="arcgis-categoria">Categoría <span class="required-indicator">*</span><FieldHelp label="la categoría" :text="help.categoria" /></label>
          <select
            id="arcgis-categoria"
            class="input"
            :value="formData.categoria"
            @change="changeCategory($event.target.value)"
          >
            <option value="-1" disabled>
              {{ categories.length === 0 ? "Cargando opciones..." : "Seleccione una categoría" }}
            </option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>

        <!-- Orden -->
        <div class="form-row">
          <label for="arcgis-orden">Orden dentro de la categoría <span class="required-indicator">*</span><FieldHelp label="el orden dentro de la categoría" :text="help.orden" /></label>
          <LayerOrderFormModal
            id="arcgis-orden"
            :category-id="formData.categoria"
            :category-name="selectedCategoryName"
            :current-layer-id="currentLayerId"
            :current-layer-name="formData.nombre"
            :value="formData.orden"
            :layer-order-ids="formData.layerOrderIds"
            @input="updateField('orden', $event)"
            @order-change="updateField('layerOrderIds', $event)"
          />
        </div>

        <p class="note"><span class="required-indicator">(*)</span> Obligatorio</p>
      </div>
    </div>

  </div>
</template>

<script>
import LayerOrderFormModal from "./LayerOrderFormModal.vue";
import FieldHelp from "@/components/FieldHelp.vue";
import { LAYER_FIELD_HELP } from "./layerFieldHelp.js";
import VulnerableReportIconField from "./VulnerableReportIconField.vue";

export default {
  name: "FormularioArcgisPaso1",

  components: {
    LayerOrderFormModal,
    FieldHelp,
    VulnerableReportIconField
  },

  data() {
    return {
      help: LAYER_FIELD_HELP
    };
  },

  model: {
    prop: "formData",
    event: "update:formData"
  },

  props: {
    formData: { type: Object, required: true },
    categories: { type: Array, required: true },
    currentLayerId: { type: String, default: "" }
  },

  computed: {
    selectedCategoryName() {
      const category = this.categories.find(item => item.id === this.formData.categoria)
      return category ? category.name : ''
    },
    isImageServer() {
      return /\/imageserver$/i.test((this.formData.url || "").trim());
    },
    urlError() {
      const url = this.formData.url;
      if (!url) return null;

      // 1. Validar protocolo
      if (!/^https?:\/\//i.test(url)) {
        return "La URL debe comenzar con http:// o https://";
      }

      // 2. Validar que no termine en /
      if (url.endsWith("/")) {
        return "La URL no debe terminar en '/' (slash)";
      }

      // 3. Validar que no termine en número (índice de capa)
      if (/\/\d+$/.test(url)) {
        return "La URL no debe terminar con el índice (ej: /0). Colóquelo en el campo 'Código'.";
      }

      // 4. Validar formato general (simple)
      // Comprueba que después del protocolo haya algo que parezca un dominio/IP
      const pattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
      if (!pattern.test(url)) {
        return "El formato de la URL no es válido";
      }

      return null;
    }
  },

  methods: {
    changeCategory(categoryId) {
      this.$emit("update:formData", {
        ...this.formData,
        categoria: categoryId,
        orden: 0,
        layerOrderIds: null
      });
    },
    updateField(key, newValue) {
      this.$emit("update:formData", { ...this.formData, [key]: newValue });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./_layerForm.scss";

/* Restos de un intento anterior de los iconos de ayuda de QA-73, resuelto finalmente con el
   componente FieldHelp. Sin uso en el template actual. */
.input-with-button {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-info {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #3c8dbc;
  background-color: #fff;
  color: #3c8dbc;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-info:hover {
  background-color: #3c8dbc;
  color: #fff;
}
</style>
